import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DateHeaderSettings from './DateHeaderSettings';
import { TextField } from '@mui/material';
import { getMaxDate, getMinDate } from '../../../../helpers/date/datePickerHelper';

const MyDatePicker = (
    { field, value, labelText, isDirty, isError, error, onBlur, onChange, maxDateType, maxDateValue, minDateType, minYearEnter, isDisable, location }, 
    ...props
) => {

    const [years, setYears] = useState([])
    const [maxDate, setMaxDate] = useState('')
    const [minDate, setMinDate] = useState('')

    useEffect(() => {
        setSettings()
    }, [location, maxDateType, maxDateValue, minDateType, minYearEnter])

    const setSettings = () => {
        let arrYears = []

        const dateMax = getMaxDate({ maxDateType, maxDateValue })
        const dateMin = getMinDate({ minDateType, minYearEnter })

        for(let i = dateMin.minYear; i <= dateMax.maxYear; i++) {
            arrYears.push(i)
        }

        setYears(arrYears)
        setMaxDate(dateMax.max)
        setMinDate(dateMin.min)
    }

    const change = (date, event) => {
        // console.log('event.type', event.type)
        if (event && event.type === 'change'){ // Если человек вводит в форму вручную
            if (event.target.value.length >= 10) { // Проверяем чтобы символов в дате было 10 и более (автоматически обрежет)
                field.onChange(date)
                onBlur()
            } else if (event.target.value.length === 0) {
                field.onChange('')
                onBlur()
            }
        } else if (event.type === 'click') { // если нажатие из календаря
            field.onChange(date)
            onBlur()
        }
    }

  return (
    <div>
        <DatePicker
            portalId="root-portal"
            renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
            }) => (
                <DateHeaderSettings
                    date={date}
                    years={years}
                    changeYear={changeYear}
                    changeMonth={changeMonth}
                    decreaseMonth={decreaseMonth}
                    increaseMonth={increaseMonth}
                    prevMonthButtonDisabled={prevMonthButtonDisabled}
                    nextMonthButtonDisabled={nextMonthButtonDisabled}
                />
            )}
            dateFormat='dd.MM.yyyy' 
            placeholderText={
                '__.__._____'
                // !isDisable ? '__.__._____' :
                // location ? '__.__._____' : getLocaleTrFile('gcSelectCarLocation', locale)
            }
            customInput={
                <TextField
                    label={labelText ? labelText : ''}
                    size="small"
                    error={isDirty && isError ? true : false} // чтобы был текст ошибки
                    color={
                        isDirty && isError ? 'error' :
                        isDirty && !isError ? 'success' : ''
                    } // чтобы был успешный цвет
                    focused={isDirty ? true : false} // для отображения ошибки или успеха при выходе из поля
                    helperText={isDirty ? error : ''} //Текст ошибки
                    onBlur={e => onBlur(e)}
                    InputLabelProps={{
                        shrink: true
                    }}
                />
            }
            maxDate={maxDate}
            minDate={minDate}
            selected={field.value ? field.value : ''} 
            onBlur={e => onBlur(e)}
            onChange={(date, event) => {
                change(date, event)
            }}
            disabled={
                !isDisable ? false :
                location ? false : true
            }
            {...props}
        />
    </div>
  )
}

export default MyDatePicker